var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "nativewind/jsx-runtime";
import SccTouchableOpacity from '@/components/SccTouchableOpacity';
import React from 'react';
import { Text } from 'react-native';
export default function ExpandToggleButton(_a) {
    var { status } = _a, props = __rest(_a, ["status"]);
    return (_jsx(SccTouchableOpacity, Object.assign({ elementName: "expand_toggle", className: "rounded-[100px] border-[1px] border-gray-25 px-[27.5px] py-2" }, props, { children: _jsxs(Text, { className: "text-center font-pretendard-regular text-[14px] leading-[20px] text-black", children: [status === 'collapse' && '더보기', status === 'expand' && '접기'] }) })));
}
